import { __awaiter } from "tslib";
import { ScheduleCitationService } from "@/services/models/schedule/scheduleCitation";
const moduleScheduleCitationArchive = {
    namespaced: true,
    state: {
        consultation_id: null,
        schedule_id: null,
        service_node_id: null,
        day_selected_date: null,
        patient_id: null,
        node_id: null,
        paginate: false,
        professional_id: null,
        loading: false,
        scheduleCitations: [],
        has_archive_request: null,
        archive_request_state: null,
        order_by: null,
        scheduleCitation: null,
        selectedScheduleCitation: [],
        consultation_type_id: null,
        schedule_archive_request: null,
        page: 1,
    },
    getters: {
        getScheduleCitationArchive(state) {
            return state;
        },
        getLoading(state) {
            return state.loading;
        },
        getScheduleCitations(state) {
            return state.scheduleCitations;
        },
        getSelectedScheduleCitation(state) {
            return state.selectedScheduleCitation;
        },
    },
    mutations: {
        setScheduleCitationArchiveFilter(state, data) {
            console.log(data);
            state.day_selected_date = data.date;
            state.node_id = data.nodeId;
            state.order_by = data.order;
            state.paginate = true;
        },
        setScheduleCitationArchive(state, data) {
            console.log("XX", data);
            state.professional_id = data.professional_id || state.professional_id;
            state.consultation_id = data.consultation_id || state.consultation_id;
            state.schedule_id = data.schedule_id || state.schedule_id;
            state.service_node_id = data.service_node_id || state.service_node_id;
            state.day_selected_date = data.day_selected_date || state.day_selected_date;
            state.node_id = data.node_id || state.node_id;
            state.paginate = data.paginate || state.paginate;
            state.patient_id = data.patient_id || state.patient_id;
            state.has_archive_request = data.has_archive_request || state.has_archive_request;
            state.archive_request_state = data.archive_request_state || state.archive_request_state;
            state.order_by = data.order_by || state.order_by;
            state.consultation_type_id = data.consultation_type_id || state.consultation_type_id;
            state.schedule_archive_request = data.schedule_archive_request || state.schedule_archive_request;
        },
        setSelectedScheduleCitation(state, scheduleCitation) {
            state.selectedScheduleCitation = scheduleCitation;
        },
        setSelectedScheduleCitationPushOne(state, scheduleCitation) {
            state.selectedScheduleCitation.push(scheduleCitation);
        },
        setRemoveElementScheduleCitation(state, scheduleCitation) {
            state.selectedScheduleCitation = state.selectedScheduleCitation.filter((data) => data.id != scheduleCitation.id);
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setScheduleCitations(state, scheduleCitations) {
            state.scheduleCitations = scheduleCitations;
        },
        setScheduleCitationPage(state, page) {
            state.page = page;
        },
        cleanDataToFilterCitationArchive(state) {
            state.consultation_id = null;
            state.schedule_id = null;
            state.service_node_id = null;
            state.day_selected_date = null;
            state.node_id = JSON.parse(window.localStorage.getItem("stablishment"));
            state.professional_id = null;
            state.paginate = true;
            state.patient_id = null;
            state.has_archive_request = null;
            state.archive_request_state = null;
            state.consultation_type_id = null;
            state.order_by = "ASC";
            state.schedule_archive_request = null;
        },
    },
    actions: {
        getScheduleCitationArchive({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULE_CITATIONS = yield ScheduleCitationService.getByFilterAll(state);
                commit("setScheduleCitations", SCHEDULE_CITATIONS);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleScheduleCitationArchive;
